import VerifyEmailBlock from './VerifyEmailBlock';
import { VerifyEmailBlockProps, VerifyEmailBlockValueProps } from './types';

export type { VerifyEmailBlockProps, VerifyEmailBlockValueProps };
export default VerifyEmailBlock;
